<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-btn @click="getPendingOrder" black>Get Processing Orders</v-btn>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="dateRangeText"
          placeholder="Search with date range"
          prepend-icon="mdi-calendar"
          readonly
          v-on:click="showDateSelector = !showDateSelector"/>
<!--        <v-btn @click="getHistoryOrders" block>-->
<!--          <span>Get</span></v-btn>-->
      </v-col>
    </v-row>
    <v-row v-if="completedOrders.length == 0 && completedOrderMessage.length > 0">
      <v-col cols="12">
        {{completedOrderMessage}}
      </v-col>
    </v-row>
    <v-list dense v-else-if="completedOrders.length > 0" class="pa-0">
      <v-card class="mb-2" v-for="pendingOrder in completedOrders" :key="pendingOrder.id">
        <v-row class="pa-3 order-item-state-0" v-bind:class="{'order-item-delivered': pendingOrder.delivered==true, 'order-item-state-100': pendingOrder.state == 100}" no-gutters align="center">
          <v-col cols="12" v-if="userType === 'admin'">
            <div class="h6">{{getMerchantTitle(pendingOrder.merchantId)}}</div>
          </v-col>
          <v-col cols="6">

            <div class="h6">#{{pendingOrder.id}} <span v-if="pendingOrder.delivered == false">{{pendingOrder.deliveryDate}}</span><span v-else>{{pendingOrder.deliveredDate}}</span></div>
          </v-col>
          <v-col class="text-right" cols="6">
            <div class="h6 pr-2">
              <span v-if="pendingOrder.delivered == true">Delivered</span>
              <span v-else-if="pendingOrder.state < 100">Processing</span>
            </div>
            <!--            <div class="caption">TEXT</div>-->
          </v-col>
<!--          <v-col class="text-right" cols="2">-->
            <!--            <v-icon>fas fa-sign-out-alt</v-icon>-->
<!--          </v-col>-->
        </v-row>
        <v-row v-for="order in pendingOrder.list" :key="order.id" no-gutters class="mx-4">
          <v-col>
            <v-row align="start">
              <template v-if="order.state >= 0">
                <v-col cols="8" class="pa-1">
                  <div class="subtitle-2 py-0" v-text="order.title"/>
                  <div class="text-left caption" v-for="note in order.notes" :key="note.id" v-text="captionMemo(note)" />
                </v-col>
                <v-col cols="4" class="pa-1">
                  <div class="text-right font-weight-bold caption">
                    <span>{{order.amount}}</span>
                    <span v-if="order.useVariablePrice == true"><br>({{(order.variablePriceAmount/100.0).toFixed(1)}}kg)</span>
                  </div>
<!--                  <div class="text-right font-weight-bold caption">£{{(order.totalPrice / 100).toFixed(2)}}</div>-->
<!--                  <div class="text-right font-weight-bold caption">VAT: £{{(order.tax / 100).toFixed(2)}}</div>-->
<!--                  <div class="text-right font-weight-bold caption">Total: £{{(order.finalDue / 100).toFixed(2)}}</div>-->
                </v-col>
              </template>
              <template v-else-if="order.state < 0">
                <v-col cols="8">
                  <div class="subtitle-2 py-0">
                    <strike style="color:red;">
                      <span style="color:gray;">{{order.title}}</span>
                    </strike>
                  </div>
                  <div class="text-left caption" v-for="note in order.notes" :key="note.id" v-text="captionMemo(note)" />
                </v-col>
                <v-col cols="4">
                  <div class="text-right font-weight-bold caption">{{order.amount}}</div>
                  <div class="text-right font-weight-bold caption" style="color:red;">Cancelled</div>
                </v-col>
              </template>
            </v-row>
          </v-col>
        </v-row>
<!--        <v-divider class="ma-0"/>-->
<!--        <v-row>-->
<!--          <v-col class="text-center">-->
<!--            <button class="btn btn-success" v-on:click="duplicateOrder(pendingOrder)">Duplicate Order</button>-->
<!--          </v-col>-->
<!--        </v-row>-->
        <v-divider class="ma-0"/>
        <v-row v-if="pendingOrder.notes !== null && pendingOrder.notes.length > 0" no-gutters class="mx-4">
          <v-col>
                      <v-list-item-title class="text-left">
                        ORDER MEMO
                      </v-list-item-title>
                        <template v-if="pendingOrder.notes.length > 0">
            <div class="text-left caption"  v-for="note in pendingOrder.notes" :key="note.id">{{note.userName}}: {{note.description}}</div>
                        </template>
          </v-col>
        </v-row>
<!--        <bill label="TOTAL PRICE"   :value="pendingOrder.totalPrice"/>-->
<!--        <bill label="VAT"           :value="pendingOrder.tax"/>-->
<!--        <bill label="Due"           :value="pendingOrder.finalDue"/>-->
<!--        <bill label="DC"            :value="pendingOrder.discountAmount" v-if="pendingOrder.discountAmount !== 0"/>-->
        <bill v-if="pendingOrder.delivered == false" label="DELIVERY DATE" :text="pendingOrder.deliveryDate"/>
        <bill v-else label="DELIVERED TIME" :text="timeStringMDHM(pendingOrder.deliveredTime)"/>
        <v-row v-if="pendingOrder.delivered == true">
          <v-col cols="6">
            <img width="90%" :src="pendingOrder.signatureUrl"/>
          </v-col>
          <v-col cols="6">
            <v-list-item-title class="text-right pr-5">
              Signed By<br><strong>{{pendingOrder.signatureName}}</strong>
            </v-list-item-title>

          </v-col>
        </v-row>
        <v-row v-if="pendingOrder.deliveryNotes != null && pendingOrder.deliveryNotes.length > 0">
          <v-col class="text-right">
            <button class="btn btn-success" style="margin-right:10px;" v-on:click="sendDeliveryNote(pendingOrder)">Delivery Note</button>
          </v-col>
        </v-row>

      </v-card>
    </v-list>
    <v-dialog v-model="showDateSelector">
        <v-date-picker
          v-model="dates"
          range/>
        <v-btn v-on:click="getHistoryOrders">
          <span>SEARCH</span>
        </v-btn>
    </v-dialog>
    <v-dialog v-model="basketDialog">
      <v-card>
        <v-card-title>
          Added to basket
        </v-card-title>
        <v-card-subtitle style="padding-top:20px;">
          {{basketDialogMessage}}
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="green darken-1" text @click="basketDialog = false">Stay</v-btn>
          <v-btn color="green darken-1" text @click="moveToBasket">Move to Basket</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import {
    getAdminMerchants,
    getDeliveryDay,
    getOrderList,
    loadBasket,
    newChildOrder, newChildOrderFromOrder, saveBasket,
    sendDeliveryNote
  } from "../api/order";
    import {millisToDate, millisToMMDDHHMM, showDialog} from "../api/utils";
    import Bill from "./Bill";
  import {getUserByToken} from "../api/user";
  import EventBus from "../api/event-bus";

    export default {
        name: "OrdersCompleted",
        components: {Bill},
        data() {
          return {
            completedOrders:[],
            completedOrderMessage:'',
            startDate:'',
            toDate:'',
            dates:[],
            showDateSelector:false,
            merchants:[],
            userType:'merchant',

            basketDialog:false,
            basketDialogMessage:'',
          }
        },
        created() {
          // let now = new Date();
          // let old = new Date();
          // old = old.setDate(old.getDate() - 7);
          // this.$data.dates[0] = millisToDate(old, '-');
          // this.$data.dates[1] = millisToDate(now.getTime(), '-');
          this.getUser();
          this.getPendingOrder();
        },
      beforeDestroy() {
        },
        computed: {
          dateRangeText () {
            return this.dates.join(' ~ ')
          },
        },
        methods: {
          timeStringMDHM:millisToMMDDHHMM,
          getUser: function() {
            let self = this;
            getUserByToken()
            .then(function(data) {
              if(data.type === 'ROLE_ADMIN' || data.type === 'ROLE_MANAGER') {
                self.$data.userType = 'admin';
                self.getMerchantList();
              } else if(data.type === 'ROLE_MERCHANT') {
                self.$data.userType = 'merchant';
              }
            })
            .catch(function(err) {

            })
          },
          getMerchantList: function() {
            let self = this;
            getAdminMerchants()
            .then(function(data) {
              if(data.success == true) {
                self.$data.merchants = data.item;
              }
            })
          },
          getPendingOrder: function() {
            let query = "stateFrom=0&stateTo=90";
            let self=this;
            this.$data.completedOrders = [];
            this.$data.completedOrderMessage = '';
            getOrderList(query)
              .then(function(data) {
                if(data.success) {
                  self.$data.completedOrders = data.item;
                } else {
                  self.pendingOrderMessage = data.message;
                }
              })
          },
          getHistoryOrders: function() {
            this.showDateSelector = false

            if(this.$data.dates.length == 0) {
              showDialog("Please select date range");
              return;
            }
            this.$data.completedOrders = [];
            this.$data.completedOrderMessage = '';
            let query = "stateFrom=0&stateTo=100";
            // var start = new Date(this.$data.dates[0]);
            // start.setHours(0,0,0,0);
            // var end = new Date(this.$data.dates[1]);
            // end.setHours(23,59,59,999);
            if(this.$data.dates[0] > this.$data.dates[1]) {
              let temp = this.$data.dates[1];
              this.$data.dates[1] = this.$data.dates[0];
              this.$data.dates[0] = temp;
            }

            query += "&deliveryFrom=" + this.$data.dates[0] + "&deliveryTo=" + this.$data.dates[1];
            let self = this;
            getOrderList(query)
            .then(function(data) {
              if(data.success == true) {
                self.$data.completedOrders = data.item.reverse();
              } else {
                self.$data.completedOrderMessage = data.message;
              }
            })
            .catch(function(err) {

            })
          },
          timestampToDate: function (timestamp) {
            let date = new Date(timestamp)

            return date.toISOString().substring(0, 10)
          },
          captionMemo(note){
            return `${note.userName}: ${note.description}`
          },
          getMerchantTitle: function(id) {
            if(this.$data.merchants.length == 0) {
              return '';
            }

            for(let i = 0 ; i < this.$data.merchants.length ; i++) {
              if(this.$data.merchants[i].id == id) {
                return this.$data.merchants[i].title;
              }
            }
            return id;
          },
          sendDeliveryNote: function(order) {
            sendDeliveryNote(order.id)
            .then(function(data) {
              if(data.success == true) {
                showDialog(data.message);
              } else {
                showDialog(data.message);
              }
            })
            .catch(function(err){
              showDialog("Sorry problem happpened", "ERROR");
            })
          },
          duplicateOrder: function(order) {
            if(order.list == undefined || order.list == null || order.list.length == 0) {
              return;
            }

            let basketOrder = loadBasket(0)
            console.log(basketOrder);

            // if(basketOrder.vendorId == 0) {
            //   basketOrder.deliveryDate = getDeliveryDay(this.$data.deliveryDates);
            // }

            for(let o = 0 ; o < order.list.length ; o++) {
              let found = false;
              if (basketOrder.list != null && basketOrder.list.length > 0) {
                for (let i = 0; i < basketOrder.list.length; i++) {
                  if (basketOrder.list[i].productId == order.list[o].productId && basketOrder.list[i].vendorId == 0) {
                    basketOrder.list[i].amount += order.list[o].amount;
                    basketOrder.list[i].totalPrice = basketOrder.list[i].price * basketOrder.list[i].amount;
                    basketOrder.list[i].tax = basketOrder.list[i].totalPrice * basketOrder.list[i].taxRate / 10000;
                    basketOrder.list[i].finalDue = basketOrder.list[i].totalPrice + basketOrder.list[i].tax;
                    found = true;
                    break;
                  }
                }
              }

              if (found == false) {
                let newOrder = newChildOrderFromOrder(order.list[o], '')


                console.log(newOrder);
                basketOrder.list.push(newOrder)

              }
            }
            let totalPrice = 0;
            let tax = 0;
            for(let i = 0 ; i < basketOrder.list.length ; i++) {
              totalPrice += basketOrder.list[i].totalPrice;
              tax += basketOrder.list[i].tax;
            }

            basketOrder.totalPrice = totalPrice;
            basketOrder.tax = tax;
            basketOrder.finalDue = totalPrice + tax;
            saveBasket(basketOrder, 0)
            EventBus.$emit('onBasket',1);
            this.$data.basketDialogMessage = "Do you want to move to basket page?"
            this.$data.basketDialog = true;
          },
          moveToBasket: function() {
            this.$data.basketDialog = false;
            this.$router.push('/basket');
          }
        },


    }
</script>

<style scoped>
  h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    margin: 0;
    padding: 0;
  }
  .order-item-state-0, .order-item-state-10, .order-item-state-30 {
    background-color: #B4DBFF;
  }
  .order-item-delivered, .order-item-state-100 {
    background-color: #4076FE;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrdersCompleted.vue